import React, { useState, useEffect } from 'react';
import { commonSelector } from '../Common/redux/selectors';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import FAQ from '../CommonResp/FAQ/FAQ';
import Footer from '../CommonResp/Footer/Footer';
import Tile from '../CommonResp/Tile/Tile'
import Heading from '../CommonResp/Heading/Heading';
import Breadcrumbs from '../CommonResp/BreadcrumbsWithoutSchema/Breadcrumbs';
import { isMobileView, capitalize, getDefaultFilters } from '../Common/utils';
import { redirectToFunnel } from '../Common/utils/redirectToFunnel';
import Carousel from '../CommonResp/Carousel/Carousel';
import { getBPDPView, getHotelsView } from './../CommonResp/CrossLinkFunction'
import MobileHeader from '../CommonResp/MobileHeader/MobileHeader';
import { cityDataSelector } from './../CityPage/redux/selectors'
import ListingWidget from '../CommonResp/ListingWidget/ListingWidget';
import WhiteCard from '../CommonResp/WhiteCard/WhiteCard';
import TemplateContent from '../CommonResp/Content/Content';
import { getBreadCrumbObj } from './../CommonResp/utils';
import SeoContainerHeader from "../Common/SeoContainerHeader";
import PageNotFound from '../CommonResp/PageNotFoud/PageNotFound';
import AdBanner from './../../components/AdBanner/AdBanner';
import CrossTemplate from '../CommonResp/CrossTemplate/CrossTemplateTile';
import { calculateDaysToTrip, convert_yyyymmdd_to_dd_mm_dddd, ctaHelper, CTA_TYPE, getDate, getUpdateSearchPayload, trackActionEvent, sendPageViewEvent } from '../../utils/Omniture';
import { PAGE_NAMES } from '../config/constants';



const CityRespPage = (props) => {
  const { pageType = '', pageTypeNameOmniture='' } = props;
  const commonData = useSelector(commonSelector);
  const cityStoreData = useSelector(cityDataSelector);
  const [showClientContent, enableClient] = useState(false);
  const [showAllBuses, setShowAllBuses] = useState(false);
  const mobileView = isMobileView();
  let filterStrView = "";
  let primaryFilters = []

  useEffect(() => {
    enableClient(true);
  }, []);

  useEffect(()=>{
    let pageName = ''
    if(pageTypeNameOmniture === 'city_category'){
        pageName = PAGE_NAMES.city_category
    }
    else {
        pageName = PAGE_NAMES.city  
    }
    const eventDetails = {
      pageName: pageName,
      booking: {
        routeCity: cityStoreData?.city_info?.city,
        routeState: cityStoreData?.city_info?.state_name,
        daysToTrip: calculateDaysToTrip(getDate(date)),
        departureDate: date,
      }
    };
     sendPageViewEvent(eventDetails);    
  },[]);
  
  const { date, bps, canonical_url, city_name, city_vid, dps, footer_links, from_buses = [], offers, seo_meta = {}, template, to_buses = [],
    top_operator_data = {}, cross_template_links = {}, htl_city_links = [], popular_hotels = [], from_buses_msg, to_buses_msg, dummy_data,
    general_content, src_dump, general_contents = [], notToCrawl = false, notToIndex=false } = cityStoreData;

  const { src, dest, src_vid, dest_vid, doj, dojObj, filterStr, journeyType } = commonData;
  const data_date = date ? date : doj;

  const cityDisplayName = capitalize(city_name);
  const { faq = {}, contents = [], content = "" } = template || {};
  const renderBanner = offers && offers.length
  const dummyPageView = dummy_data && !from_buses.length && !to_buses.length ? true : false;
  const renderOfferCarousel = showClientContent && offers && offers.length ? true : false;

  if (filterStr && filterStr.length) {
    filterStrView = filterStr.toUpperCase().split("-").join(" ")
    let str = filterStr.toLowerCase();
    if (str.indexOf('non-ac') !== -1) {
      primaryFilters.push('nonac');
      str = str.replace('non-ac', '')
    }
    if (str.indexOf('semi-sleeper') !== -1) {
      primaryFilters.push('sleeper');
      str = str.replace('semi-sleeper', '')

    }
    if (str.indexOf('mercedes-benz') !== -1) {
      primaryFilters.push('mercedes-benz');
      str = str.replace('mercedes-benz', '')
    }
    const types = str.split("-");
    primaryFilters = primaryFilters.concat(types);
  }

  const [selectedFilters, setSelectedFilters] = useState(getDefaultFilters('onw', primaryFilters));
  const { topOperatorView, isTopOperatorDataPresent } = getOperatorView(top_operator_data);
  const { bpView, dpView, isBPPresent, isDPPresent } = getBPDPView(bps, dps);
  const { view: htl_city_links_view_data, isDataPresent: is_htl_city_links_present } = getHotelsView(htl_city_links)
  const { view: popular_hotels_view_data, isDataPresent: is_popular_hotels_present } = getHotelsView(popular_hotels)

  const moveToFunnel = (params,track=true) => {
    const eventDetails = {
       cta : ctaHelper(['VIEW BUSES', CTA_TYPE.BUTTON, 'Body', 'SRP']),
     booking: {
          routeCity: src,
          routeState: cityStoreData?.city_info?.state_name ,
          daysToTrip: calculateDaysToTrip(getDate(date)),
          departureDate: date,
      }
  };
    if(track){
      trackActionEvent("viewBuses",eventDetails,{gloabl:true});
    }
    
    redirect(params);
  }
  const redirect = (params)=>{
    redirectToFunnel({ ...params, data_date, isFilter: pageType, selectedFilters: selectedFilters[journeyType] });     
  }
  const onUpdateSearch = (data) => {
    const {src_name,dest_name,selectedDate}  = data;
    const eventDetails = getUpdateSearchPayload({src_name,dest_name,selectedDate});
    trackActionEvent("busUpdateSearch", eventDetails);
    moveToFunnel({ page: "home", prefillData: true, data: data },false);
  }

  let title = `${cityDisplayName} Bus Ticket Booking`
  if (pageType === 'category') {
    title = `${cityDisplayName} ${filterStrView} Buses`;
  }

  const { h1_title = "", meta_title = "", meta_description = "", meta_keywords = "", breadcrumb = "" } = seo_meta;

  const breadCrumbObj = getBreadCrumbObj(breadcrumb, canonical_url);

  const adTechId = (() => {
    return "QlVTI0NJVFkgU0VPI1ZJRVcgTU9SRSBCVVNFUw=="
  })();

  return (
    <>
      <Helmet
        title={meta_title}
        meta={
          [{ name: 'description', content: meta_description },
          { name: 'keywords', content: meta_keywords },
          { property: 'og:title', content: meta_title },
          { property: 'og:description', content: meta_description },
          { property: 'og:image', content: 'https://gos3.ibcdn.com/bus-default-1489655303.jpg' },
          { property: 'og:url', content: canonical_url },
          notToCrawl ? { name: 'robots', content: 'noindex,nofollow' } : '',
          notToIndex ? { name: 'robots', content: 'noindex' } : '',
          ]
        }
        link={[
          {
            href: canonical_url,
            rel: 'canonical',
          },
        ]}
      />
      {notToCrawl ?
        <PageNotFound src={src}
          dest={city_name}
          src_id={src_vid}
          dest_id={city_vid}
          date={data_date}
          onUpdateSearch={onUpdateSearch}
          showHeaderOnly={notToCrawl}
          footer_links={footer_links}
        ></PageNotFound>
        : <>
          <Helmet>
            <script type="application/ld+json">{`${JSON.stringify(breadCrumbObj)}`}</script>
          </Helmet>
          <div className="seoContainer">
            <div className="desktopOnly">
              <SeoContainerHeader
                src={src}
                dest={city_name}
                src_id={src_vid}
                dest_id={city_vid}
                date={data_date}
                onUpdateSearch={onUpdateSearch}
              />
            </div>

            {showClientContent ?
              <MobileHeader
                title={h1_title}
                date={data_date}
                moveToFunnel={moveToFunnel}>
              </MobileHeader>
              : <></>}

            <div className="ContentWrapper">
              <div className="contentSection operatorsContentScetion">
                <div className="RgtSection">
                  <Heading content={h1_title}></Heading>
                  <Breadcrumbs content={breadcrumb}></Breadcrumbs>
                  <TemplateContent data={general_contents} className="seoDescTitle"></TemplateContent>
                </div>
                <div className="LftSection">
                  {renderOfferCarousel && !mobileView ? <Carousel content={offers} count={isMobileView() ? offers.length : 1} lazyload={false}></Carousel> : null}
                </div>
              </div>

              {dummyPageView ?
                <>
                  {/* <NoBusFound /> */}
                </>
                : <></>}

              {to_buses && to_buses.length ?
                <>
                  <p className="listingHeading">{to_buses_msg || `Book ${filterStrView} Buses To ${cityDisplayName}`}</p>
                  <ListingWidget
                    content={to_buses}
                    src_dump={src_dump}
                    showAllBuses={showAllBuses}
                    moveToFunnel={moveToFunnel}
                    showClientContent={showClientContent}
                  />
                </>
                : <></>}

              {from_buses && from_buses.length ?
                <>
                  <p className="listingHeading">{from_buses_msg || `Book ${filterStrView} Buses From ${cityDisplayName}`}</p>
                  <ListingWidget
                    content={from_buses}
                    src_dump={src_dump}
                    showAllBuses={showAllBuses}
                    moveToFunnel={moveToFunnel}
                    showClientContent={showClientContent}
                  />
                </>
                : <></>}

              {showClientContent ? <AdBanner cid={adTechId} /> : <></>}

              <TemplateContent className="whiteCard" data={contents} content={content}></TemplateContent>

              <FAQ data={faq}></FAQ>

              <WhiteCard content={topOperatorView} heading={`Top Bus Operators in ${cityDisplayName}`} isContent={isTopOperatorDataPresent}></WhiteCard>

              <div className="whiteCardWrapper">
                <Tile tileHeading={`Pickup Points in ${cityDisplayName}`} tileContent={bpView} isTileContent={isBPPresent}></Tile>
                <Tile tileHeading={`Drop points in ${cityDisplayName}`} tileContent={dpView} isTileContent={isDPPresent}></Tile>
                <CrossTemplate cross_template_links={cross_template_links} />

                {htl_city_links && htl_city_links.length ?
                  <Tile tileHeading={`Top hotels in ${dest}`} tileContent={htl_city_links_view_data} isTileContent={is_htl_city_links_present}></Tile> : null}
                {popular_hotels && popular_hotels.length ?
                  <Tile tileHeading={`Popular hotels in ${dest}`} tileContent={popular_hotels_view_data} isTileContent={is_popular_hotels_present}></Tile> : null}
              </div>
            </div>
            <Footer data={footer_links}></Footer>
          </div>
        </>}
    </>
  )
}
export default CityRespPage;

export const getOperatorView = (data) => {
  let view = []
  let liView = [];
  for (let index in data) {
    const { name, slug } = data[index];
    liView.push(
      <li key={name + index}>
        {slug ? <a href={`${__ENV_CONFIG__.__GOIBIBO__}${slug}`} title={name}>{name}</a> : <span title={name}>{name}</span>}
      </li>
    )
  }
  if (liView && liView.length) {
    view.push(<ul key={"topOperatorView"}>{liView}</ul>)
  }
  return { topOperatorView: view, isTopOperatorDataPresent: view.length ? true : false };
}
